import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { OptInNudgeInput, optInOrigin } from "@faire/retailer-visitor-shared/components/Banners/OptInNudgeBanners/OptInNudgeInput";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import * as React from "react";
import styled from "styled-components";
var NudgeText = function() {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "pageHeaderSerifRegular",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "62Zjni",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Stay in the know"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansRegular",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "PKU+3s",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Keep up with our latest offers, seasonal events, and recommendations for products we think you\u2019ll love."
                        }
                    ]
                })
            })
        ]
    });
};
export var OptInNudgeFooterBanner = function() {
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx(NudgeText, {}),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            /*#__PURE__*/ _jsx(OptInNudgeInput, {
                origin: optInOrigin.FOOTER_PAGE
            })
        ]
    });
};
var Container = styled(Column).attrs({
    align: {
        mobileAndAbove: "normal",
        desktopAndAbove: "flex-start"
    }
}).withConfig({
    componentId: "sc-cd09723d-0"
})([
    "",
    "{border-top:1px solid ",
    ";padding:",
    ";width:100vw;}",
    "{padding:",
    ";}",
    "{max-width:456px;padding:",
    ";}"
], responsiveMediaQueries.mobile, Core.surface.subdued, getSpacing("3x"), responsiveMediaQueries.tablet, getSpacing("4x", "8x", "8x", 96), responsiveMediaQueries.desktopAndAbove, getSpacing("3x", 96, "5x", 0));
